import moment from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Col,
  Container,
  Form,
  Input,
  Modal,
  ModalBody,
  Row,
  Spinner,
} from "reactstrap";
import { refreshAuth } from "store/actions/authAction";
import { addContract } from "store/actions/contractAction";

const ContractModal = ({ contractModal }) => {
  let dispatch = useDispatch();
  let { user, uid } = useSelector((state) => state.auth);
  console.log(user);
  let date = user?.created_at?.seconds
    ? moment.unix(user.created_at.seconds).format("DD/MM/YYYY")
    : "N/A"; 
  let [formData, setFormData] = useState({
    customer: user?.school,
    name: "",
  });
  const [loader, setLoader] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    let obj = {
      id: uid,
      name: formData.name,
    };
    dispatch(
      addContract(obj, () => {
        dispatch(
          refreshAuth(uid, () => {
            setLoader(false);
            toast.success("Your Contract add successfully");
          })
        );
      })
    );
    console.log(formData);
  };

  return (
    <Modal isOpen={!contractModal} centered size="xl">
      <ModalBody className="contract_modal">
        <Container>
          <Form onSubmit={handleSubmit}>
            <h1 className="text-center mb-4">
              <u>SERVICES AGREEMENT</u>
            </h1>
            <p>
              This Service Agreement <b>(“Agreement”)</b> is made and entered as
              of <Input value={date} className="w-25 d-inline" />{" "}
              <b> (“Effective Date”),</b> by and between FansHelpPlayers, LLC{" "}
              <b>(“FHP”)</b> and{" "}
              <Input value={formData.customer} className="w-25 d-inline mt-1" />{" "}
              <b>(“Customer”),</b> each being referred to individually as a{" "}
              <b> “Party,”</b> and collectively as the
              <b> “Parties”</b> throughout this Agreement.{" "}
            </p>
            <p>
              &emsp; &emsp; <b> WHEREAS,</b> FHP operates an online platform,
              whereon fans may engage with various athletes registered thereon{" "}
              <b>(“FHP Brand Ambassadors”),</b> including, but not limited to,
              purchasing goods and/or services offered by FHP Brand Ambassadors
              (the <b> “Platform”</b>);
            </p>
            <p>
              &emsp; &emsp; <b> WHEREAS,</b> the Platform enables certain
              colleges/universities to register on the Platform for the purpose
              of depositing funds to be dispersed as “cashback payments” to
              qualified fans relating to such fans interactions and/or
              engagement with certain FHP Brand Ambassadors{" "}
              <b> (“Cashback Payment Management Services”);</b> and
            </p>
            <p>
              &emsp; &emsp; <b> WHEREAS,</b> the Parties wish to set forth the
              terms and conditions pursuant to which FHP shall perform the
              Cashback Payment Management Services for and/or on behalf of
              Customer, in accordance with the terms set forth in this
              Agreement.
            </p>
            <p>
              &emsp; &emsp; <b>NOW, THEREFORE,</b> in consideration of the
              mutual promises and conditions contained in this Agreement, and
              for other good and valuable consideration, the receipt of which is
              hereby acknowledged, the Parties agree as follows:
            </p>
            <h1 className="text-center">
              <u>TERMS AND CONDITIONS</u>
            </h1>
            <ol>
              <li>
                <b>
                  <u>Adoption of Recitals.</u>
                </b>{" "}
                The above recitations are true and correct and are incorporated
                herein by this reference. The Parties hereby cancel and revoke
                all prior agreements between them relating to the subject matter
                of this Agreement, whether oral or written.
              </li>
              <li>
                <b>
                  <u>Term; Termination. </u>
                </b>
                <ol type="a">
                  <li>
                    <b>Term:</b> The term of this Agreement shall commence on
                    the Effective Date, and shall remain in full force and
                    effect for a period of five (5) years, unless sooner
                    terminated in accordance with the terms set forth in this
                    Agreement (“Term”).{" "}
                  </li>
                  <li>
                    <b>Termination:</b> Either Party shall have the right to
                    terminate this Agreement, at any time, with or without
                    cause, upon at least thirty (30) days advance written notice
                    provided to the other Party.{" "}
                  </li>
                  <li>
                    <b>Effect of Termination:</b> Upon termination or expiration
                    of this Agreement, Customer acknowledges that Customer shall
                    remain responsible for paying FHP for its performance of
                    Cashback Payment Management Services up to the effective
                    date of termination, including, without limitation, any and
                    all expenses incurred relating thereto.
                  </li>
                </ol>
              </li>
              <li>
                <b>
                  <u> Cashback Payment Management Services.</u>
                </b>{" "}
                During the Term, FHP agrees to provide the Cashback Payment
                Management Services, as more fully described in the Scope of
                Work attached hereto as
                <b>
                  <u> Exhibit A.</u>
                </b>{" "}
                Customer agrees it is acquiring only a non-transferable,
                non-exclusive right to the Cashback Payment Management Services.
                FHP shall at all times retain exclusive title to the Platform
                and Cashback Payment Management Services, including, without
                limitation, any invention, development, product, trade name,
                trademark, service mark, software program, or derivative
                thereof, developed in connection with providing the Cashback
                Payment Management Services or otherwise by FHP during the Term
                of this Agreement.
              </li>
              <li>
                <b>
                  <u> Compensation.</u>
                </b>{" "}
                In exchange for FHP’s performance of Cashback Payment Management
                Services, Customer agrees to pay FHP in accordance with the
                terms set forth in{" "}
                <b>
                  <u> Exhibit A </u>(“Compensation”).
                </b>
              </li>
              <li>
                <b>
                  <u> Non-Disparagement.</u>
                </b>{" "}
                Customer agrees that at no time during or after the Term will
                Customer disparage FHP or FHP’s goods and services, including,
                but not limited to: (i) FHP’s performance of Cashback Payment
                Management Services, or (ii) the Platform.
              </li>

              <li>
                <b>
                  <u> Confidentiality.</u>
                </b>{" "}
                The Parties acknowledge and agree that the terms of this
                Agreement, and any and all confidential information regarding a
                Party or its operations that is disclosed by a Party to the
                other in furtherance of this Agreement, including, without
                limitation, information concerning the Parties’ operating and
                marketing methods, pricing practices, sales figures, revenue,
                and/or any other information deemed a trade secret,
                confidential, or proprietary by the disclosing Party{" "}
                <b> (“Confidential Information”)</b> will be treated as
                confidential and will not be disclosed to any third party
                (except as set forth herein) at any time during the Term of this
                Agreement or thereafter or used for any purposes other than for
                purposes contemplated by this Agreement. <br />
                <br />
                Each Party agrees to: (i) protect the other Party’s Confidential
                Information using the same standard of care it uses to protect
                its own Confidential Information, provided that in no event will
                a Party use less than a reasonable standard of care; and (ii)
                not disclose the other Party’s Confidential Information, except
                to its affiliates, employees, independent contractors, and
                agents who express a “need to know” and have agreed in writing
                or are otherwise under a legal duty to keep such information
                confidential at a level no less protective than required herein.
                Each Party (and any affiliates, contractors, employees and
                agents to whom it has disclosed Confidential Information) may
                use the other Party’s Confidential Information only to the
                extent necessary to fulfill its duties and obligations contained
                within this Agreement, and each Party acknowledges that it shall
                be responsible for the actions of any of its affiliates,
                partners, contractors, employees, and agents that are in
                violation hereof. All Confidential Information shall be the
                exclusive property of the disclosing Party and shall be returned
                to the disclosing Party, or destroyed, immediately upon the
                termination or expiration of this Agreement, or at any other
                time at the disclosing Party’s request. <br />
                <br />
                Each Party may disclose the other Party’s Confidential
                Information when required by law but only to the extent
                necessary to comply with such law and only after such Party, if
                legally permissible: (i) uses commercially reasonable efforts to
                notify the other Party; and (ii) gives the other Party the
                chance to challenge or limit the disclosure. <br /> <br />{" "}
                Notwithstanding the foregoing, “Confidential Information” does
                not include: (i) information in the public domain or made
                generally available without breach of this Agreement by the
                receiving Party, (ii) information received from a third party
                owing no duty of confidentiality to the disclosing Party; or
                (iii) information independently developed by a Party, without
                use or access to the other Party’s Confidential Information.{" "}
              </li>
              <li>
                <b>
                  <u>Representations and Warranties.</u>
                </b>{" "}
                Each Party represents, warrants, and covenants to the other
                Party that it has the full right and power to (i) enter into
                this Agreement, (ii) perform all obligations to be performed by
                it hereunder, and (iii) grant all rights hereunder granted, in
                each case without violating the legal or equitable rights of any
                other person or entity.
              </li>
              <li>
                <b>
                  <u>Indemnification.</u>
                </b>{" "}
                Customer shall defend, indemnify and hold harmless FHP, and
                FHP’s officers, directors, employees, representatives, and
                members, (collectively,<b> “FHP Indemnitees”</b>), from and
                against any and all claims, suits, losses, damages and expenses
                (including reasonable attorney’s fees and expenses), resulting
                from third party claims made or suits brought against any FHP
                Indemnitee to the extent based on any action or omissions by or
                on behalf of Customer, including, without limitation, those
                based upon: (i) Customer’s deposit of funds on the Platform;
                (ii) FHP’s disbursement of funds deposited by Customer in
                accordance with FHP’s performance of Cashback Payment Management
                Services; (iii) any negligent act, error or omission, violation
                of applicable law, or willful misconduct of Customer, or any
                third party acting for or on behalf of Customer; and/or (iv)
                Customer’s breach of any term, condition, representation, or
                warranty contained in this Agreement (each a <b>“Claim”</b>). If
                any Claim is brought against an FHP Indemnitee, Customer will
                defend such Claim at Customer’s sole expense using counsel
                selected by the FHP Indemnitee. If Customer fails to take timely
                action to defend such Claim, the FHP Indemnitee may defend such
                Claim at Customer’s expense, including, without limitation,
                automatically adding such expenses as Compensation payable under
                this Agreement and deducted from deposits provided by Customer.
                Customer shall cooperate in all reasonable respects with the
                investigation, disclosure and defense of any Claim. Customer
                will not settle, compromise or otherwise enter into any
                agreement regarding the disposition of any Claim against an FHP
                Indemnitee without the prior written consent and approval of the
                FHP Indemnitee.
              </li>
              <li>
                <b>
                  <u>Limitation of Liability.</u>
                </b>{" "}
                Notwithstanding Customer’s duty to indemnify FHP in accordance
                with Section 8 of this Agreement, in no event shall either Party
                be liable to the other Party for any special, exemplary,
                indirect, incidental, consequential, or punitive damages of any
                kind or nature whatsoever (including, without limitation, lost
                revenue, profits, savings, or business), whether in an action
                based on contract, warranty, strict liability, tort (including,
                without limitation, negligence) or otherwise, even if such Party
                has been informed in advance of the possibility of such damages,
                or if such damages could have reasonably been foreseen by such
                Party.{" "}
              </li>
              <li>
                <b>
                  <u>Waiver.</u>
                </b>{" "}
                The failure of either Party to exercise the rights granted to
                such Party under this Agreement upon the occurrence of any of
                the contingencies set forth in this Agreement shall not in any
                event constitute a waiver of any such rights upon the occurrence
                of any additional such contingencies.
              </li>
              <li>
                <b>
                  <u>Notices.</u>
                </b>{" "}
                Any notice required to be given hereunder shall be given by
                sending the same by email, overnight express mail or registered
                or certified mail, postage prepaid, return receipt requested to
                the address stated herein, or to any subsequent address
                designated by either Party for the purpose of receiving notices
                pursuant to this Agreement. All notices shall be deemed validly
                given: (i) after one (1) business day if sent via email or
                overnight express mail, or (ii) after five (5) business days if
                sent via registered or certified mail. Notices shall be sent to
                the following:
                <Row className="mt-4">
                  <Col md="4">
                    <p>If to FHP:</p>
                  </Col>
                  <Col md="4">
                    <p>
                      128 DORCHESTER F <br />
                      WEST PALM BEACH, FL 33417 <br />
                      Email: fanshelpplayers@gmail.com
                    </p>
                  </Col>
                  <Col md="4"></Col>
                  <Col md="4">
                    <p>If to Customer: </p>
                  </Col>
                  <Col md="4">
                    {/* <Input type="textarea" /> */}
                    Email.
                    <Input type="email" value={user.email} />
                  </Col>
                </Row>
              </li>
              <li>
                <b>
                  <u>Press Release; Promotion.</u>
                </b>{" "}
                The Parties may, upon mutual agreement, issue a press release
                upon execution of this Agreement or issue other public marketing
                and communications materials during the Term detailing and/or
                promoting the business arrangement hereunder.{" "}
              </li>
              <li>
                <b>
                  <u>Force Majeure.</u>
                </b>{" "}
                In the event that either Party’s performance of any of its
                respective duties and obligations under this Agreement is
                prevented or hindered due to any act of God, fires, strikes,
                labor disputes, accidents, embargoes, riots, floods,
                earthquakes, wars, pandemic, epidemic, injury, illness,
                governmental actions, or other circumstances beyond the control
                of such Party (each, a <b> “Force Majeure Event”</b>), then such
                performance shall wholly or partially be suspended during the
                period in which the Force Majeure Event is in existence, and no
                Party shall be liable to the other Party during such period
                owing to such circumstances; provided, in the event such Force
                Majeure Event last for period of ninety (90) consecutive days,
                either Party shall have the right to immediately terminate this
                Agreement.
              </li>
              <li>
                <b>
                  <u>Severability.</u>
                </b>{" "}
                In the event any provision of this Agreement is determined to be
                invalid by a court of competent jurisdiction, such determination
                shall in no way affect the validity or enforceability of any
                other provision contained herein.
              </li>
              <li>
                <b>
                  <u>Governing Law; Dispute Resolution.</u>
                </b>{" "}
                This Agreement shall be governed by and construed in accordance
                with the laws of the State of Florida, without regard to
                conflict of law principles thereof. Each Party agrees that
                binding arbitration under the Commercial Rules of Arbitration of
                the American Arbitration Association before a single arbitrator
                shall resolve any dispute or controversy arising in connection
                with this Agreement. Any such arbitration shall be conducted in
                Broward County, Florida. Judgment upon any award may be entered
                in any court of competent jurisdiction. The decision of the
                arbitrator shall be binding and conclusive upon the Parties. In
                the event of any legal action or arbitration proceeding brought
                for the enforcement of this Agreement, the prevailing party
                shall be entitled to recover reasonably incurred attorney’s fees
                and costs. Notwithstanding, this agreement to binding
                arbitration shall not prevent either Party from seeking
                injunctive and/or other equitable relief from a court of
                competent jurisdiction located in Broward County, Florida.
              </li>
              <li>
                <b>
                  <u>Relationship of the Parties</u>
                </b>
                <ol type="a">
                  <li>
                    <b>Independent Contractor:</b> The Parties acknowledge that
                    FHP shall provide the Cashback Payment Management Services
                    solely as an independent contractor, and nothing contained
                    in this Agreement shall be interpreted or construed by the
                    Parties, or by any third party, as creating a joint venture,
                    employer-employee, or any other kind of principal-agency
                    relationship between the Parties. Neither Party shall have
                    the power or authority to bind the other with respect to
                    third parties or to represent to third parties that they
                    have such authority. Customer expressly acknowledges and
                    agrees that FHP will not withhold any federal, state or
                    local income or unemployment insurance or social security
                    taxes from any payments made under this Agreement (except
                    where tax withholding is otherwise required by law), and
                    that it is the responsibility of Customer to report and pay
                    all income, unemployment insurance, social security and
                    other taxes on Customer’s own behalf.
                  </li>
                  <li>
                    <b>Non-Exclusivity:</b> FHP reserves the right to enter into
                    other agreements pertaining to the Cashback Payment
                    Management Services with others including, without
                    limitation, other colleges/universities. Customer
                    acknowledges that during the Term, FHP shall have the right
                    to provide Cashback Payment Management Services to other
                    customers and/or clients.{" "}
                  </li>
                </ol>
              </li>
              <li>
                <b>
                  <u>No Third-Party Beneficiaries.</u>
                </b>{" "}
                Nothing contained herein, expressed or implied, is intended or
                shall be construed to confer upon or give to any person or
                entity, other than the Parties to this Agreement and their
                respective successors and permitted assigns, any rights or
                remedies under or by reason of this Agreement. This Agreement,
                and all provisions and conditions hereof, are intended to be,
                and shall be, for the sole and exclusive benefit of the Parties
                and their respective successors and permitted assigns, and not
                for the benefit of any other person or entity.
              </li>
              <li>
                <b>
                  <u>Assignment.</u>
                </b>{" "}
                This Agreement and any rights or obligations of Customer
                hereunder shall not be assigned or delegated, whether by
                transfer, merger, operation of law or otherwise, without FHP’s
                prior written consent. FHP may assign and/or sublicense its
                rights hereunder to any affiliate or successor entity in the
                event of a merger, reorganization or sale of FHP or
                substantially all of its assets. All provisions of this
                Agreement are binding upon, shall inure to the benefit of, and
                are enforceable by or against the Parties and their respective
                heirs, executors, administrators or other legal representatives
                and permitted successors and assigns.
              </li>
              <li>
                <b>
                  <u>Entire Agreement.</u>
                </b>{" "}
                This Agreement and schedules attached hereto constitute the
                entire understanding between the Parties with respect to the
                subject matter of this Agreement and supersedes all prior
                agreements whether written or oral. No waiver, modification or
                addition to this Agreement shall be valid unless made in writing
                and signed by the Parties hereto. This Agreement may be executed
                concurrently in one or more counterparts, each of which shall be
                an original, but all of which together shall constitute one and
                the same instrument. This Agreement shall not be binding upon
                either Party until executed by an authorized officer thereof.
              </li>
            </ol>
            <p>
              &emsp; &emsp;<b> IN WITNESS WHEREOF,</b> the Parties have duly
              executed this Agreement as of the Effective Date written above.
            </p>
            <Row>
              <Col md="6">
                <h2>
                  {" "}
                  <b>CUSTOMER </b>
                </h2>
                <div>
                  BY:
                  <Input type="text" value={formData.customer} />
                </div>
                <div>
                  Name:
                  <Input
                    type="text"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        name: e.target.value,
                      }))
                    }
                    required
                    placeholder="Enter Your Name"
                  />
                </div>
                <p>I have authority to bind Customer</p>
              </Col>
              <Col md="6">
                <h2>
                  <b>FANSHELPPLAYERS, LLC</b>
                </h2>
                <div>
                  BY:
                  <Input type="text" value={"FHP"} />
                </div>
                <div>
                  Name:
                  <Input type="text" value={"James Beecham"} />
                </div>
                <p>I have authority to bind FHP</p>
              </Col>
            </Row>
            <h1 className="text-center my-4">
              <u>EXHIBIT A</u>
            </h1>
            <h2 className="text-center mb-4">
              <u>Scope of Work</u>
            </h2>

            <p>
              This Scope of Work supplements, and is governed by, the Services
              Agreement by and between FansHelpPlayers, LLC <b> (“FHP”)</b> and
              <Input
                value={formData.customer}
                className="w-25 d-inline mt-1"
              />{" "}
              <b> (“Customer”)</b> dated as of
              <Input value={date} className="w-25 d-inline" />
              (the <b> “Agreement”</b>). The terms and conditions of the
              Agreement will apply to the Parties’ agreement hereunder, except
              that to the extent of any conflict between the Agreement and this
              Scope of Work, this Scope of Work will control. Unless otherwise
              indicated, all capitalized terms used but not defined herein will
              have the meanings ascribed to them in the Agreement.
            </p>

            <ol type="1">
              <li>
                <b> Services.</b> During the Term, FHP shall provide Cashback
                Payment Management Services as follows:
                <ol type="a">
                  <li>
                    {" "}
                    Customer shall share a portion of Customer’s revenue and/or
                    otherwise deposit funds <b> (“Funds”)</b> with the Platform;
                    and
                  </li>
                  <li>
                    Upon receipt of the Funds, FHP shall disperse the Funds to
                    certain fans according to Customer’s instructions, which
                    instructions shall direct FHP to disperse said Funds as
                    “cash-back” reimbursements relating to those certain fans
                    purchase of eligible products and/or services from FHP Brand
                    Ambassadors on the Platform <b> (“Instructions”).</b>
                  </li>
                </ol>
              </li>
              <li>
                <b>Compensation.</b> In exchange for FHP’s performance of
                Cashback Payment Management Services, Customer agrees to pay FHP
                four and a half percent (4.5%) of the gross amount of Funds
                deposited on the Platform <b> (“Compensation”)</b>. Payment of
                Compensation shall be immediately due and payable upon
                Customer’s deposit thereof, and Customer acknowledges that FHP
                shall have the right to deduct the Compensation and other
                Expenses (as defined) relating thereto immediately upon
                Customer’s deposit of the Funds.
                <b> “Expenses”</b> shall mean any and all processing fees, tax,
                and/or other fees incurred by FHP relating to the performance of
                Cashback Payment Management Services.
              </li>
              <li>
                Rules and Procedures. Customer acknowledges that FHP shall be
                solely responsible for establishing all rules and/or procedures
                relating to FHP’s performance of Cashback Payment Management
                Services (“Rules”). Customer agrees to fully comply with all of
                the terms and obligations in FHP’s then current Rules, as
                changed or updated by FHP from time to time, at FHP’s sole
                reasonable discretion with notice in accordance with the terms
                of the Agreement.
              </li>
              <li>
                <b>Rules and Procedures.</b> Customer acknowledges that FHP
                shall be solely responsible for establishing all rules and/or
                procedures relating to FHP’s performance of Cashback Payment
                Management Services <b>(“Rules”)</b>. Customer agrees to fully
                comply with all of the terms and obligations in FHP’s then
                current Rules, as changed or updated by FHP from time to time,
                at FHP’s sole reasonable discretion with notice in accordance
                with the terms of the Agreement.
              </li>
              <li>
                <b>Platform’s Requirements and Upgrades.</b> Customer agrees
                that the Cashback Payment Management Services shall be provided
                in accordance with the Platform’s then current systems,
                standards and Rules and that FHP shall not be required to
                perform any special programming, to provide any special hardware
                or software or to implement any other system, program or
                procedure for Customer. Unless otherwise agreed in writing by
                FHP, all sales transaction, settlement and other data and
                information used in connection with the Cashback Payment
                Management Services shall be provided to Customer according to
                the Platform’s then current data formats and by means of the
                Platform’s then current telecommunications configurations and
                protocols. FHP may make changes in the Platform and/or Cashback
                Payment Management Services based upon, but not limited to,
                technological developments, legislative or regulatory changes,
                or the introduction of new services by FHP.{" "}
              </li>
              <li>
                <b>Service Suppliers.</b> FHP may use one or more Service
                Suppliers (as defined herein) in connection with its performance
                of the Cashback Payment Management Services. Deposit of Funds
                and/or other transaction are processed by third party payment
                processors. Any Service Supplier may have its own terms and
                conditions <b> (“Third Party Terms”)</b> and Customer should
                ensure Customer is in agreement with any Third Party Term prior
                to making depositing any Funds. If Customer’s transaction with
                any Service Supplier (including, but not limited to, any third
                party payment processor) is not successful, then Customer’s
                deposit will not be fulfilled. <b> “Service Supplier”</b> shall
                mean a third party use by FHP in connection with the performance
                of Cashback Payment Management Services, including but not
                limited to, FHP’s software providers, equipment providers,
                and/or third-party payment processors.
              </li>
              <li>
                <b> FHP Duties and Responsibilities.</b> In providing the
                Cashback Payment Management Services, Customer acknowledges that
                FHP’s sole responsibility shall be management and disbursement
                of Funds in accordance with Customer’s Instructions. In
                furtherance thereof, Customer acknowledges the following:
                <ol type="a">
                  <li>
                    FHP shall be protected in relying upon the accuracy, acting
                    in reliance upon the contents, and assuming the genuineness
                    of any Instructions that are given to FHP by Customer
                    without verifying the truth or accuracy of any such
                    Instructions;
                  </li>
                  <li>
                    FHP’s performance of Cashback Payment Management Services
                    are purely ministerial, and shall be limited to the
                    safekeeping and disposition of the Funds in accordance with
                    the provisions of this Agreement. FHP shall not be liable
                    for any action taken or omitted by FHP in good faith and
                    believed by FHP to be authorized in accordance with
                    Instructions received from Customer, except for any damage
                    caused by FHP 's own gross negligence or willful misconduct.
                    FHP shall not have any liability or obligation for loss of
                    all or any portion of the Funds by reason of the insolvency
                    or failure of the institution of depository with whom the
                    Funds are maintained. Upon the disbursement of the Funds in
                    accordance with Customer’s Instructions, FHP shall be
                    relieved and released from any liability relating to the
                    disbursement of such Funds; and
                  </li>
                  <li>
                    {" "}
                    Customer shall indemnify and hold harmless FHP from and
                    against any liabilities, damages, losses, costs, or expenses
                    incurred by, or claims or charges made against FHP
                    (including reasonable attorneys' fees and expenses) by
                    reason of FHP action (or inaction) in reliance of
                    Instructions provided by Customer, except for those matters
                    arising as a result of FHP’s gross negligence or willful
                    misconduct.
                  </li>
                </ol>
              </li>
            </ol>
            {/* <Button color="secondary" onClick={contractToggle}>
            Cancel
          </Button> */}
            <div className="text-right">
              <Button color="primary" type="submit">
                {loader ? <Spinner size="sm" /> : " Submit"}
              </Button>
            </div>
          </Form>
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default ContractModal;
